import { uiHeaderSearchBar } from 'components/BionicUI/CutCorners';
import BPKeyboardShortcut from 'components/BionicUI/keyboardShortcut/BPKeyboardShortcut';
import Eye from 'components/onboarding/Eye';
import { cn } from 'lib/utils';
import { FC, useEffect, useMemo, useState } from 'react';
import GlobalSearchPopup, { SearchContext } from './GlobalSearchPopup';
import SearchResult from './result/SearchResult';
import { placeholders } from './GlobalSearchInput';

interface HeaderSearchBarProps {
  searchContext?: SearchContext;
}

const HeaderSearchBar: FC<HeaderSearchBarProps> = ({ searchContext }) => {
  const [showGlobalSearch, setShowGlobalSearch] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>();
  const [showSearchResult, setShowSearchResult] = useState<boolean>(false);

  const openSearchBox = (event: KeyboardEvent) => {
    event.preventDefault();
    onClickOpenSearchBox();
  };

  const onClickOpenSearchBox = () => {
    if (!showGlobalSearch) {
      setShowGlobalSearch(true);
      setSearchTerm('');
    }
  };

  const searchForTerm = (term: string) => {
    setShowGlobalSearch(false);
    setSearchTerm(term);
  };

  useEffect(() => {
    if (!searchTerm) return;
    setShowSearchResult(true);
  }, [searchTerm]);

  const placeholder = useMemo(
    () => placeholders[searchContext?.scope ?? 'global'],
    [searchContext]
  );

  return (
    <div
      className="hidden md:block relative w-[50vw] max-w-[592px] h-[56px] rounded-r-full rounded-l-full backdrop-blur-md bg-white/5 overflow-hidden cursor-pointer animate-fade-in"
      onClick={onClickOpenSearchBox}
    >
      <Glow />
      <GradBorder />
      <div className="grid absolute top-0 left-0 w-full h-full grid-cols-[auto_1fr_auto] gap-3 justify-start items-center p-[8px] pr-[24px]">
        <div className="block relative w-[40px] h-[40px]">
          <Eye showBorder id="eye-video-search-bar" />
        </div>
        <div className="block relative text-[16px] text-white/50">
          {placeholder}
        </div>
        <BPKeyboardShortcut
          shortcutKey={'k'}
          modifier="ctrl"
          callback={openSearchBox}
          enabled={!showGlobalSearch}
        />
      </div>
      {showGlobalSearch && !showSearchResult && (
        <GlobalSearchPopup
          handleClose={() => setShowGlobalSearch(false)}
          searchContext={searchContext}
          searchForTerm={searchForTerm}
        />
      )}
      {showSearchResult && (
        <SearchResult
          searchContext={searchContext}
          searchTerm={searchTerm}
          handleClose={() => setShowSearchResult(false)}
        />
      )}
    </div>
  );
};

const Glow = () => (
  <div className="grid absolute -top-[40px] left-0 w-full h-[40px] justify-center items-center">
    <div className="block relative w-[462px] h-[40px] bg-white/50 rounded-[50%] blur-[10px]" />
  </div>
);

const GradBorder = () => (
  <div
    className={cn(
      'block absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/30 to-white/5',
      uiHeaderSearchBar.border
    )}
  />
);

export default HeaderSearchBar;
